// src/features/categories/categoriesApi.ts
import { api } from '@/store/api'
import type { Category, GetCategoriesParams } from './types'

const listTagId = (params?: GetCategoriesParams): string =>
  `LIST_${params?.kind ?? 'course'}_${params?.languageFilter ?? 'profile'}`

export const categoriesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCategories: build.query<Category[], GetCategoriesParams | void>({
      query: (params) => {
        const search = new URLSearchParams()
        if (params?.kind) search.set('kind', params.kind)
        if (params?.search) search.set('search', params.search)
        if (params?.languageFilter) search.set('languageFilter', params.languageFilter)
        const qs = search.toString()
        return `categories/${qs ? `?${qs}` : ''}`
      },
      providesTags: (_res, _err, params) => [
        { type: 'Category' as const, id: listTagId(params || undefined) },
      ],
    }),
    getAvailableCategories: build.query<Category[], GetCategoriesParams | void>({
      query: (params) => {
        const search = new URLSearchParams()
        if (params?.kind) search.set('kind', params.kind)
        if (params?.search) search.set('search', params.search)
        const qs = search.toString()
        return `categories/available${qs ? `?${qs}` : ''}`
      },
      providesTags: (_res, _err, params) => [
        { type: 'Category' as const, id: `AVAILABLE_${params?.kind ?? 'course'}` },
      ],
    }),
  }),
})

export const { useGetCategoriesQuery, useGetAvailableCategoriesQuery } = categoriesApi
